import { useCurrentInternalUserQuery } from "src/queries/user.generated";

/** A hook for hard-coded/q&d access control to procurement UW features. */
export function useIsProcurementUWUser(): boolean {
  const { data: currentInternalUserData } = useCurrentInternalUserQuery({ fetchPolicy: "cache-first" });
  const email = currentInternalUserData?.currentInternalUser?.email;
  return !!email && procurementUWUsers.includes(email);
}

const procurementUWUsers = [
  "dlehmann@homebound.com",
  "rhassell@homebound.com",
  "ecarter@homebound.com",
  "lrutherford@homebound.com",
  "zkarlovich@homebound.com",
  "jscott@homebound.com",
  "gmurillo@homebound.com",
];
